const PLACEHOLDER_EMAIL = "unassigned@local.internal";

/** Resolve assigned staff account id from a shift row (schedule/jobs/detail). */
export function getShiftAssignedAccountId(shiftRow) {
  if (!shiftRow) return null;
  const raw =
    shiftRow.assigned_staff_id ??
    shiftRow.assigned_account_id ??
    shiftRow.staff_account_id ??
    shiftRow.account_id ??
    shiftRow.accountId ??
    shiftRow.shiftAccountId ??
    shiftRow.shift_account_id ??
    shiftRow.staff_id;
  const id = Number(raw);
  return Number.isFinite(id) && id > 0 ? id : null;
}

function isPlaceholderStaffAccount(shiftRow) {
  const email = String(
    shiftRow?.staff_email ??
      shiftRow?.assigned_staff_email ??
      shiftRow?.email ??
      "",
  )
    .trim()
    .toLowerCase();
  return email === PLACEHOLDER_EMAIL;
}

function getShiftAssignmentUiStatus(shiftRow) {
  return String(
    shiftRow?.assignment_ui_status ?? shiftRow?.assignmentUiStatus ?? "",
  )
    .trim()
    .toLowerCase();
}

/** Assignee for duplicate-shift checkbox (id + display name), or null if unassigned. */
export function getDuplicateAssignee(shiftRow) {
  if (!shiftRow || isPlaceholderStaffAccount(shiftRow)) return null;

  if (getShiftAssignmentUiStatus(shiftRow) === "unassigned") return null;

  const accountId = getShiftAssignedAccountId(shiftRow);
  if (!accountId) return null;

  const displayName =
    String(shiftRow.assigned_staff_name || "").trim() ||
    [shiftRow.first_name, shiftRow.last_name]
      .map((p) => String(p || "").trim())
      .filter(Boolean)
      .join(" ");

  if (!displayName) return { accountId, displayName: "Staff" };

  return { accountId, displayName };
}
